import axios from 'axios';
// import moment from 'moment';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'pip_code','pip_name','reklass', 'isactive'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/pip${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
    pipAccount() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/pip/pipaccount");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    

    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("pip", obj);
                resolve(data);

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.delete(`pip/${obj.pipkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url ;
            let str = '';
            try {
                // switch (obj.fsubkode2) {
                //     case 'arinvtt':
                //         str = '?key=' + encodeURIComponent(obj.subkode2);
                //         url = `/arinv/printjv`;
                //         break;

                //     case 'tranbank':
                //         str ='?key=' + encodeURIComponent(obj.subkode2);
                //         if (obj.nomor.substr(1, 1) == 'M'){
                //             url = `/tranbank/printreceivejv`;

                //         } else {
                //             url = `/tranbank/printpaymentjv`;
                //         }
                //         break;

                //     default:
                        // // str = `?nomor=${encodeURIComponent(obj.nomor)}&tanggal=${encodeURIComponent(moment(obj.tanggal).format('YYYY-MM-DD'))}`;
                            const keys = ['nomor', 'tanggal', 'kodejurnal'];
                            str = '';
                            for (const key in obj) {
                                if (keys.indexOf(key) >= 0 && obj[key]) {
                                    str += str ? '&' : '?';
                                    str += key + '=' + encodeURIComponent(obj[key]);
                                }
                            }
                            url = `/pip/printjv`;
                //         break;
                // }

                url += str;
                const { data } = await axios.get(url);

                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });

    },
    exportxls(obj = {}) {
        // return new Promise(async (resolve, reject) => {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'pip_code','pip_name','reklass', 'isactive'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/pip/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Project_in_progress.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }

};